import {Grid, Select, SelectProps, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';


const MySelect = ({label, children, ...props}: SelectProps<any>): JSX.Element => {

    const theme = useTheme();

    const labelStyle = {
        color: props.disabled 
            ? theme.s10palette.S10Greygrey300 
            : theme.s10palette.S10Greygrey700,
        fontSize: "1rem",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "1.25",
        
    };

    const inputStyles = {
        height: "2.5rem", 
        fontSize: "1rem",
        margin: "0px",
        background: "white",
        borderRadius: "0.25rem",
        ...props?.style,
    };
    if (props.value && !props.error) {
        inputStyles.border = `1px solid ${theme.s10palette.S10Blueblue300}`;
        inputStyles.borderRadius = "0.25rem"
    }
    if (props.error) {
        inputStyles.border = `1px solid ${theme.s10palette.S10Redred500}`;
        inputStyles.borderRadius = "0.25rem"
    }
    return (
        <Grid item>
            {label && <Typography 
                // variant="caption"
                align='left'
                style={labelStyle}
            >
                {label}
            </Typography>}
            <Select
                {...props}
                variant="outlined"
                // hiddenLabel
                // onChange={(event: { target: { value: string } }) => {
                //     const value = event.target.value;
                //     if (props?.onChange) {
                //         props.onChange(value, null)
                //     }
                // }}
                value={props.value}
                style={inputStyles}
                // InputProps={{...props.InputProps, style: inputStyles}}
            >
                {children}
            </Select>
        </Grid>
    );
}

export default MySelect;